import { useIntl } from 'react-intl';

import { QuestionCircleIcon } from '../icons/QuestionCircleIcon';
import { Tooltip } from '../ui/Tooltip';
import { ChanceToMatch } from '../../types/loanType';
import styles from './ChanceToMatchIndicator.module.less';

interface ChanceToMatchIndicatorProps {
  chanceToMatch: ChanceToMatch | null;
}

const stylesMap: Record<ChanceToMatch, string> = {
  [ChanceToMatch.LOW]: styles.low,
  [ChanceToMatch.MEDIUM]: styles.medium,
  [ChanceToMatch.HIGH]: styles.high,
  [ChanceToMatch.VERY_HIGH]: styles.veryHigh,
  [ChanceToMatch.NA]: styles.na,
};

const translationMap: Record<ChanceToMatch, string> = {
  [ChanceToMatch.LOW]: 'loanType.chanceToMatch.low',
  [ChanceToMatch.MEDIUM]: 'loanType.chanceToMatch.medium',
  [ChanceToMatch.HIGH]: 'loanType.chanceToMatch.high',
  [ChanceToMatch.VERY_HIGH]: 'loanType.chanceToMatch.veryHigh',
  [ChanceToMatch.NA]: 'loanType.chanceToMatch.na',
};

export const ChanceToMatchIndicator = ({
  chanceToMatch,
}: ChanceToMatchIndicatorProps) => {
  const intl = useIntl();

  if (chanceToMatch === null) {
    return null;
  }

  return (
    <div>
      <div className={styles.text}>
        {intl.formatMessage(
          { id: 'loanType.chanceToMatch.text' },
          {
            chance: (
              <span className={stylesMap[chanceToMatch]}>
                {intl.formatMessage({ id: translationMap[chanceToMatch] })}
              </span>
            ),
          }
        )}
        <Tooltip
          content={intl.formatMessage({ id: 'loanType.chanceToMatch.tooltip' })}
        >
          <QuestionCircleIcon />
        </Tooltip>
      </div>
    </div>
  );
};
